import {filterArrayUndefined} from '@coolcolduk/util';
import {mapProgressDbToType, Progress} from '@cp/model';
import {getDocs} from 'firebase/firestore';
import getProgressCollectionRef from './getProgressCollectionRef';

export default async function fetchProgressList(uid: string): Promise<Progress[]> {
  const col = getProgressCollectionRef(uid);
  const snapshot = await getDocs(col);
  return filterArrayUndefined(snapshot.docs.map((d) => mapProgressDbToType(d)));
}
